// Default setting props

const pagProps = {
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  }
}

const navProps = {
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
}

const fullNavProps = {
  ...pagProps, ...navProps
}

const cv2Props = {
  slidesPerColumn: 2,
  slidesPerView: 2,
}

const gv2Props = {
  slidesPerGroup: 2,
  slidesPerView: 2,
}

const gv3Props = {
  slidesPerGroup: 3,
  slidesPerView: 3,
}

const gv4Props = {
  slidesPerGroup: 4,
  slidesPerView: 4,
}

const gv5Props = {
  slidesPerGroup: 5,
  slidesPerView: 5,
}

const autoplayProps = {
  delay: 5000,
  pauseOnMouseEnter: true,
}

export { pagProps, navProps, fullNavProps, gv2Props, cv2Props, gv3Props, gv4Props, gv5Props, autoplayProps };